import React, { useState } from 'react'
import './videoCard.css'
import {
   AngryIcon,
   EyesIcon,
   HappyIcon,
   LikeIcon,
   LoveIcon,
   SedIcon,
   VideoImage,
   VideoInfoIcon
} from 'assets'
import { useLocation, useNavigate } from 'react-router-dom'
import { createImageUrl } from 'utils/createImageUrl'
import dayjs from 'dayjs'
import { formatNumber } from 'utils/formatNumber'
import { getSentimentIcon } from 'utils/getSentimentIcon'
import { getEmotionIcon } from 'utils/getEmotionIcon'
import { removeUtcFormate } from 'utils/removeUtcFormate'
import { instagramPostType, videStatusConst } from 'constant/const'
import { toastError } from 'utils/toastify'
import { useDispatch, useSelector } from 'react-redux'
import { toggleInstagramVideoSelection } from 'store/action/instagramDashboard'
import { isVideoUrl } from 'utils/isImageOrVideo'

function PostCard(props) {
   const { items, type } = props
   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const { selectedVideoIds, isBatchAnalysisStatus } = instagramDashboardData
   const navigate = useNavigate()
   const location = useLocation()
   const [isClicked, setIsClicked] = useState(false)
   const dispatch = useDispatch()

   const onRedirect = (type) => {
      if (!isClicked) {
         setIsClicked(true)
         if (items?.comment_count > 0) {
            navigate(`/instagram/posts-reel/${items.id}`, {
               state: {
                  loadingMessage:
                     items?.total_analyzed_comments === 0 ? 'Analyzing post, please wait…' : '',
                  type: type
               }
            })
         } else {
            toastError(
               'You don’t have any Instagram post comments available for analysis at the moment.'
            )
            setIsClicked(false)
         }
      }
   }
   const handleCheckboxChange = () => {
      dispatch(toggleInstagramVideoSelection(items.id))
   }
   return (
      <div className="card video-card">
         <div className="post-video-image-section  video-image-section position-relative">
            {/* <img
               src={items?.thumbnails ? createImageUrl(items?.thumbnails) : VideoImage}
               alt="video"
            /> */}
            {/* {items?.media_type === instagramPostType.VIDEO ? (
               <>
                  <video src={items?.media_url} autoPlay={false}></video>
                  <div className="gradient-overlay"></div>
               </>
            ) : (
            )} */}
            {items?.media_type === instagramPostType.VIDEO ? (
               <>
                  {items?.thumbnail_url ? (
                     isVideoUrl(items?.thumbnail_url) ? (
                        <video
                           src={createImageUrl(items?.thumbnail_url)}
                           autoPlay={false}
                           
                        />
                     ) : (
                        <img
                           src={createImageUrl(items?.thumbnail_url)}
                           alt="InPostImage"
                           className="mw-100"
                        />
                     )
                  ) : (
                     <video src={items?.media_url} autoPlay={false}  />
                  )}
                  <div className="gradient-overlay"></div>
               </>
            ) : (
               <img
                  src={createImageUrl(items?.thumbnail_url)}
                  alt="InPostImage"
                  className="mw-100"
               />
            )}
            {items?.status === videStatusConst.processing ? (
               <div className="video-processing-ui">
                  <div className="video-blur-bg" />
                  <div className="video-processing-message">
                     <div className="loader"></div>
                     <span>Analyzing Post...</span>
                  </div>
               </div>
            ) : (
               !isBatchAnalysisStatus && (
                  <>
                     <div className="video-hover-buttons">
                        <button
                           className="video-btn primary"
                           onClick={() => {
                              items?.is_analyzed ? onRedirect('') : onRedirect('quick')
                           }}>
                           {items?.is_analyzed ? 'View Analysis' : 'Quick Analysis'}
                        </button>
                        <button className="video-btn secondary" onClick={() => onRedirect('full')}>
                           Full Analysis
                        </button>
                     </div>
                  </>
               )
            )}

            {/* <img src={items?.thumbnail_url} alt="InPostImage" className={`mw-100 `} /> */}
            {/* <div className="video-hover-buttons">
               <button
                  className="video-btn primary"
                  onClick={() => {
                     onRedirect('quick')
                  }}>
                  {items?.is_analyzed ? 'View Analysis' : 'Quick Analysis'}
               </button>
               <button
                  className="video-btn secondary"
                  onClick={() => {
                     onRedirect('full')
                  }}>
                  Full Analysis
               </button>
            </div> */}
            {items?.is_analyzed && (
               <div className="video-show-emotion">
                  <div className="d-flex gap-2">
                     {items?.top_emotion?.emotion && (
                        <div className="text-wrapper" title="Sentiment">
                           <div className="text-wrapper-video-icon">
                              {items?.top_emotion &&
                                 getSentimentIcon(items?.top_emotion?.top_sentiment)}
                           </div>
                           <span className="ms-2 me-2 at-text-dark">{items?.sentiment_score}</span>
                        </div>
                     )}
                  </div>
                  {items?.top_emotion?.emotion && (
                     <div className="d-flex align-items-center gap-2">
                        <div className="text-wrapper">
                           <div className="text-wrapper-video-icon text-emotion-icon">
                              {/* <NeutralIcon /> */}
                              {getEmotionIcon(
                                 items?.top_emotion?.emotion,
                                 items?.top_emotion?.top_sentiment
                              )}
                           </div>
                           <span className="ms-2 me-1 at-text-dark text-capitalize">
                              {items?.top_emotion?.emotion}
                           </span>
                        </div>
                     </div>
                  )}
               </div>
            )}
            {items?.comment_count > 0 && isBatchAnalysisStatus && (
               <input
                  type="checkbox"
                  className="at-checkbox-video-card form-check-input"
                  checked={selectedVideoIds.includes(items.id)}
                  onChange={handleCheckboxChange}
               />
            )}
         </div>
         <div className="video-detail">
            <span className="at-text-light video-date mb-2">
               {items?.timestamp
                  ? dayjs(removeUtcFormate(items?.timestamp)).format('D MMMM, YYYY')
                  : ''}
            </span>
            {/* <h3 title={items?.title} className="video-name mb-2">
               {items?.title}
            </h3> */}
            <p className="at-text-light video-comments">
               {items?.comment_count || 0} comments posted ·{' '}
               <span className="video-comments-analysis">
                  {items?.analyzed_comment_count || 0} analyzed{' '}
               </span>
            </p>
            <div className="video-icon mt-3">
               {items?.media_type === instagramPostType.VIDEO && (
                  <div className="d-flex align-items-center gap-2 video-icon-wrap">
                     <div className="at-video-icon">
                        <EyesIcon />
                     </div>
                     <span className="at-text-dark video-counter">
                        {formatNumber(items?.view_count || 0, 2)}
                     </span>
                  </div>
               )}
               <div className="d-flex align-items-center gap-2 video-icon-wrap">
                  <div className="at-video-icon">
                     <LikeIcon />
                  </div>
                  <span className="at-text-dark video-counter">
                     {' '}
                     {formatNumber(items?.like_count || 0, 2)}
                  </span>
               </div>
            </div>
            {/* <div className="video-action-group">
               <div
                  className="at-btn"
                  onClick={() => {
                     navigate(`/videos/analysis/5${location?.search}`)
                  }}>
                  Get Analysis
               </div>
            </div> */}
         </div>
      </div>
   )
}

export default PostCard
